import AJAXLoader from './AJAXLoader';

/**
 * @class
 * @inheritDoc
 * @extends module:media.module:loaders.AJAXLoader
 * @memberof module:media.module:loaders
 * @classdesc Загрузчик JSON
 */
class JSONLoader extends AJAXLoader {
    constructor(src) {
        super(src, 'json');
    }
}

export default JSONLoader;